<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jsGAWa/tc-custom/9781504039109.jpg?1734099131690" alt="This image is the cover for the book Dry Your Smile"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dry Your Smile
      </h1>
      <p class="bookDescription body article font2">
        <b>A former child actor searches for her true self in this novel-within-a-novel from a leader of the international feminist movement.</b><br/><br/> Before she even turned fourteen, Julian Travis made enough money as a TV star to support her mother for life in an apartment in one of Manhattan’s best buildings. But now, Julian is in her midforties and things are not so glamorous or easy. Her mother is slowly dying of Parkinson’s, her marriage of twenty years is steadily disintegrating, and money is scarce. Though Julian is a famed feminist spokeswoman and published poet, when she looks into the mirror, she doesn’t recognize herself. That and the novel she is writing are giving her a terrible time.<br/>  <br/><i>Dry Your Smile </i>takes readers on a journey into Julian’s past—from the precarious circumstances surrounding her birth to the lies and stories her mother wove about her absent father to her childhood diary and dreams, and her subsequent escape into the arms of a revolutionary artist and a bohemian life.<br/>  <br/> In the present, Julian delves into the emotional baggage imparted by her Jewish stage-mom as a means of taking off the many masks she has worn over the years, and begins writing prose through the voice of her younger self. She also searches for a new future in a lesbian love affair with Iliana, a bisexual photographer and the one person who makes Julian feel beautiful. In the end, however, perhaps what Julian needs most is to separate herself from the expectations and images of others, and truly listen to the woman she has become.<br/>  <br/> A roman à clef of author and poet Robin Morgan’s own struggles with what it means to be a female writer in the late twentieth century, <i>Dry Your Smile</i> is an intelligent and cathartic addition to any feminist library.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robin Morgan
      </h2>
      
      <p class="authorDescription body article">Award-winning poet, novelist, journalist, and feminist leader Robin Morgan has published more than twenty books, including the now-classic&#160;anthologies <I>Sisterhood Is Powerful</I>&#160;and&#160;<I>Sisterhood Is Global</I> and the bestselling&#160;<I>The Demon Lover: The Roots of Terrorism</I>.&#160;Her work has been translated into thirteen languages, among them Arabic, Chinese, Japanese, Korean, and Persian. A recipient of honors including a National Endowment for the Arts Creative Writing Fellowship, and former editor in chief of&#160;<I>Ms</I><I>.</I>, Morgan founded the&#160;Sisterhood Is Global Institute, and with Jane Fonda and Gloria Steinem, cofounded the Women&rsquo;s Media Center. She writes and hosts&#160;<I>Women&rsquo;s Media Center Live with Robin Morgan</I>,&#160;a weekly program with a global audience on&#160;iTunes&#160;and&#160;WMCLive.com&mdash;her commentaries legendary, her guests ranging from grassroots activists to Christiane Amanpour, Anita Hill, and President Jimmy Carter.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60247339